import { useState } from "react";

import { ProjectListContainer, ProjectSection } from "./component/common/styled/project";

import SideMenu from "./component/common/component/sideMenu";
import Header from "./component/common/component/header";
import ProjectFileBoxView from "./component/projectFileBoxPage/projectFileBoxView";
import TooltipSideMenu from "../../../common/tooltipSideMenu";

const ProjectFileBoxPage = () => {
  const [showSideMenu, setShowSideMenu] = useState(false);
  const [clickSideMenu, setClickSideMenu] = useState(false);

  return (
    <ProjectSection>
      <ProjectListContainer>
        <Header clickSideMenu={clickSideMenu} setClickSideMenu={setClickSideMenu} />
        <div className="inner">
          <SideMenu showSideMenu={showSideMenu} setShowSideMenu={setShowSideMenu} />
          <ProjectFileBoxView
            setShowSideMenu={setShowSideMenu}
            showSideMenu={showSideMenu}
            clickSideMenu={clickSideMenu}
            setClickSideMenu={setClickSideMenu}
          />
        </div>
        {clickSideMenu && (
          <TooltipSideMenu
            clickSideMenu={clickSideMenu}
            setClickSideMenu={setClickSideMenu}
            isMargin={false}
          />
        )}
      </ProjectListContainer>
    </ProjectSection>
  );
};

export default ProjectFileBoxPage;
